import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Breadcrumb,
  BreadcrumbItem,
  Caption,
  Grid,
  GridColumn,
  Heading,
  TabNavigation,
  TabNavigationItem,
  Button,
  Tag,
  useSnackbar,
  Skeleton,
  Divider,
  Alert,
  Spinner,
  ButtonGroup,
  Modal,
  Body,
  IconButton,
  ProgressTracker,
  ProgressTrackerItem,
} from "@livingdesign/react";
import { useHistory, useLocation, useParams } from "react-router";
import { OVERVIEW, invoiceStatus, IS_LEAD_ATTORNEY, LABEL_APPEALED, LABEL_FAILED, LABEL_REJECTED, LEAD_ATTORNEY, MATTER_NAME, RESUBMIT_INVOICE, RESUBMIT_INVOICE_WITHOUT_VALIDATION_MSG, LABEL_DRAFT, INVOICE_EXPORT_ACTIONS, PROCESSING_PAYMENT, PAID, TERMINAL_STATUSES, CONFIRM_INVOICE_DELETION, NOT_SUBMITTED, SUBMITTED, REVALIDATION_MODAL_TITLE, REVALIDATION_MODAL_TXT, NO, YES, CREATED_INFO_MSG, LABEL_WORKFLOW } from "../../../constants/constants";
import InvoiceFiles from "../Invoice/InvoiceFiles/InvoiceFiles";
import InvoiceLineItems from "../Invoice/InvoiceLineItems/InvoiceLineItems";
import InvoiceChangeStatusModal from "../Invoice/InvoiceChangeStatusModal/InvoiceChangeStatusModal";
import {
  deleteService,
  getService, getServiceWithResponseType, patchService,
  postService,
} from "../../../axios/axios";
import {
  setInvoiceDetail,
  resetInvoiceDetail,
  setInvoiceFiles
} from "../../../store/actions/invoiceActions";
import { INVOICE_SERVICE, NODE_JS_URL } from "../../../constants/baseURLs";
import ViewEditInvoice from "./ViewEditInvoice.styles";
import LoadComponent from '../../../components/LoadComponent/LoadComponent';
import { getErrorMessage, getTabList, renderTernary, getLeadAttorneyOrParalegalWithMatterID } from "../../../helpers/utils";
import { TAB_LABEL } from '../../../constants/tabLabel';
import {
  INVOICE_STATUS_CHANGE_SUCCESS,
  INVOICE_WARNING_TITLE_MESSAGE,
  INVOICE_EMAIL_MSG,
  INVOICE_DELETE_MSG,
  REVALIDATION_IN_PROGRESS,
  REVALIDATION_IN_PROGRESS_MSG,
  REVALIDATION_IN_PROGRESS_MSG2,
  REVALIDATION_IN_PROGRESS_MSG3,
  VALIDATION_MSG
} from "../../../constants/messages";
import { ChevronDown, Trash, CheckCircleFill, QuestionCircle } from "@livingdesign/icons";
import { CANCEL, RESUBMIT, SUBMIT, EXPORT, DELETE, REVALIDATE_AND_SUBMIT, GO_BACK_TO_REVIEW, PROCEED } from "../../../constants/actionButtons";
import { displayLocalDate } from "../../../helpers/utcUtils";
import { amountFormat, getCurrencyAmount } from '../../../helpers/commonUtils';
import { Accordion, AccordionDetails, AccordionSummary, Tooltip } from "@mui/material";
import { isValueEmptyCheck } from "../../../helpers/validationUtils";
import { LoadingSkeleton } from "../../../components/LoadingSkeleton/LoadingSkeleton";
import ActionPopover from "../../../components/Table/ActionPopover/ActionPopover";
import { Refresh } from "@livingdesign/icons";
import { formSearchQuery, getExportedData } from "../../../helpers/tableUtils";
import DeleteModal from "../../../components/Modal/DeleteModal/DeleteModal";
import { Operations } from "../../../axios/operations";
import { revalidationLineItemsFlaggedMsg } from "../../../constants/templates";
import { DATE_MMM_DD_YYYY } from "../../../constants/dateFormats";
import moment from "moment";
import InvoiceNotesList from "../Invoice/InvoiceNotes/InvoiceNotesList";

const LoadField = ({ loader, skeletonHeight, skeletonVariant, skeletonLines = 1, node }) => {
  if (loader) {
    return <Skeleton height={skeletonHeight} variant={skeletonVariant} lines={skeletonLines} />;
  } else {
    return node;
  }
};

const InvoiceDetailsTiles = ({ invoiceDetail, loading }) => {
  const classes = ViewEditInvoice();
  const loadComponentProps = {
    loader: loading,
    skeletonHeight: '20px',
    skeletonWidth: '100%',
    skeletonVariant: 'reactangle',
    skeletonLines: 1
  };

  // Function to return amount if valid, else return 0
  const findAmountFigure = (amount) => {
    return amount && amount !== '-' ? amount : 0
  }

  const totalSubmittedAmount = invoiceDetail?.totalSubmittedAmount ? getCurrencyAmount(amountFormat(invoiceDetail?.totalSubmittedAmount)) : '-';
  const totalNetAmount = invoiceDetail?.totalNetAmount ? getCurrencyAmount(amountFormat(invoiceDetail?.totalNetAmount)) : '-'
  const totalDiscounts = (invoiceDetail?.totalFeeDiscounts !== undefined || invoiceDetail?.totalExpenseDiscounts !== undefined) ?
    getCurrencyAmount(amountFormat(Number(invoiceDetail.totalFeeDiscounts + invoiceDetail.totalExpenseDiscounts))) : '-';
  const totalAdjustments = (invoiceDetail?.totalFeeAdjustments !== undefined || invoiceDetail?.totalExpenseAdjustments !== undefined) ?
    getCurrencyAmount(amountFormat(findAmountFigure(invoiceDetail?.totalSubmittedAmount) - findAmountFigure(invoiceDetail?.totalNetAmount)
      + findAmountFigure(invoiceDetail?.totalFeeDiscounts) + findAmountFigure(invoiceDetail?.totalExpenseDiscounts))) : '-';

  return (
    <div className={classes.invoiceBadgesWrap}>
      <Accordion defaultExpanded={true}>
        <AccordionSummary>
          <span className={classes.accordionArrow}><ChevronDown size="medium" /></span>
          <Heading as="h1" size="medium" weight={700}>
            {OVERVIEW}
          </Heading>
        </AccordionSummary>
        <AccordionDetails>
          <Grid UNSAFE_className={classes.gridLayoutTiles}>
            <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.gridColumn}>
              <div className={classes.invoiceBadges}>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Fees Billed"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {invoiceDetail?.totalFeeBilled ? getCurrencyAmount(amountFormat(invoiceDetail?.totalFeeBilled)) : '-'}
                      </p>)}
                  </GridColumn>
                </Grid>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Fee Discounts"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {invoiceDetail?.totalFeeDiscounts ? getCurrencyAmount(amountFormat(invoiceDetail?.totalFeeDiscounts)) : '-'}
                      </p>)}
                  </GridColumn>
                </Grid>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Fee Adjustments"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {invoiceDetail?.totalFeeAdjustments ? getCurrencyAmount(amountFormat(invoiceDetail?.totalFeeAdjustments)) : "-"}
                      </p>)}
                  </GridColumn>
                </Grid>
                <div className={classes.total} />
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    <strong>{"Total Net Fees"}</strong>
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <strong className={classes.wordBreak}>
                        {invoiceDetail?.totalFeeNet ? getCurrencyAmount(amountFormat(invoiceDetail?.totalFeeNet)) : '-'}
                      </strong>)}
                  </GridColumn>
                </Grid>
              </div>
            </GridColumn>
            <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.gridColumn}>
              <div className={classes.invoiceBadges}>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Expenses Billed"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {invoiceDetail?.totalExpenseBilled ? getCurrencyAmount(amountFormat(invoiceDetail?.totalExpenseBilled)) : '-'}
                      </p>)}
                  </GridColumn>
                </Grid>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Expense Discount"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {invoiceDetail?.totalExpenseDiscounts ? getCurrencyAmount(amountFormat(invoiceDetail?.totalExpenseDiscounts)) : '-'}
                      </p>)}
                  </GridColumn>
                </Grid>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Expense Adjust"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {invoiceDetail?.totalExpenseAdjustments ? getCurrencyAmount(amountFormat(invoiceDetail?.totalExpenseAdjustments)) : '-'}
                      </p>)}
                  </GridColumn>
                </Grid>
                <div className={classes.total} />
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    <strong>{"Total Net Expenses"}</strong>
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <strong className={classes.wordBreak}>
                        {invoiceDetail?.totalExpenseNet ? getCurrencyAmount(amountFormat(invoiceDetail?.totalExpenseNet)) : '-'}
                      </strong>)}
                  </GridColumn>
                </Grid>
              </div>
            </GridColumn>
            <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.gridColumn}>
              <div className={classes.invoiceBadges}>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Submitted Amount"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {totalSubmittedAmount}
                      </p>)}
                  </GridColumn>
                </Grid>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Discount"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {totalDiscounts}
                      </p>)}
                  </GridColumn>
                </Grid>
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    {"Total Adjustments"}
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <p className={classes.wordBreak}>
                        {totalAdjustments}
                      </p>)}
                  </GridColumn>
                </Grid>
                <div className={classes.total} />
                <Grid>
                  <GridColumn sm={12} md={12} lg={7}>
                    <strong>{"Total Net Amount"}</strong>
                  </GridColumn>
                  <GridColumn sm={12} md={12} lg={4} UNSAFE_className={classes.leftGrid}>
                    {renderTernary(loading,
                      <Skeleton height="18px" variant="rectangle" />,
                      <strong className={classes.wordBreak}>
                        {totalNetAmount}
                      </strong>)}
                  </GridColumn>
                </Grid>
              </div>
            </GridColumn>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

const TabContent = (isCurrent, loading, fetchInvoiceDetail, invoiceStatusCode, fromMatter, currentMatterTab, invoiceDetail) => {
  switch (isCurrent) {
    case TAB_LABEL.LINE_ITEMS:
      return <>
        {loading ? <LoadingSkeleton /> : <InvoiceLineItems
          fetchInvoiceDetail={fetchInvoiceDetail}
          loading={loading}
          invoiceStatus={invoiceStatusCode}
          fromMatter={fromMatter}
          currentMatterTab={currentMatterTab}
        />}
      </>
    case TAB_LABEL.DOCUMENTS:
      return <InvoiceFiles loading={loading} fetchInvoiceDetail={fetchInvoiceDetail} />;
    case TAB_LABEL.NOTES:
      return <InvoiceNotesList moduleDetails={invoiceDetail} module={"invoice"} parentLoading={loading} />;
    default:
      return loading ? <LoadingSkeleton /> : <InvoiceLineItems loading={loading} fromMatter={fromMatter} fetchInvoiceDetail={fetchInvoiceDetail} />;
  }
};

const TabsLayout = ({ loading, listOfTab, tabIndexMap, listOfTabs, invoiceDetail, fetchInvoiceDetail, invoiceStatusCode, fromMatter, currentMatterTab }) => {
  const classes = ViewEditInvoice();
  const [isCurrent, setIsCurrent] = useState(tabIndexMap[listOfTabs[0]]);
  const invoiceFiles = useSelector((state) => state?.invoice?.invoiceFiles);

  return (
    <div className={classes.tabContainer} data-testid="invoice-details-tab-content">
      <TabNavigation>
        {listOfTab?.map((item, index) => (
          <TabNavigationItem
            onClick={() => setIsCurrent(tabIndexMap[item])}
            isCurrent={isCurrent === tabIndexMap[item]}
            key={tabIndexMap[item]}
            data-testid={`invoice-${item?.split(" ").join("-")}`}
            id={`invoice-${item?.split(" ").join("-")}`}
            UNSAFE_className={loading ? classes.disableTabs : ""}
          >
            {(item === "Documents" && !loading) ? `${item} (${invoiceFiles?.length})` : item}
          </TabNavigationItem>
        ))}
      </TabNavigation>
      {TabContent(isCurrent, loading, fetchInvoiceDetail, invoiceStatusCode, fromMatter, currentMatterTab, invoiceDetail)}
    </div>
  );
};

const InvoiceDetails = () => {
  const classes = ViewEditInvoice();
  const dispatch = useDispatch();
  const history = useHistory();
  const invoiceDetail = useSelector((state) => state?.invoice?.invoiceDetail);
  const { state: { fromMatter, currentMatterTab, matterNumber } = {} } = useLocation();
  const { invoiceId } = useParams();
  const { addSnack } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [resubmitLoading, setResubmitLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [invoiceStatusCode, setInvoiceStatusCode] = useState(invoiceDetail?.status || 'Void')
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const { matterDetail } = useSelector((state) => state?.matter);
  const accessibility = useSelector((state) => state?.accessibility?.applicationAccess?.financial?.invoice?.details);
  const { listOfTabs, tabIndexMap } = getTabList(accessibility?.tabs);
  const [resubmitModalOpen, setResubmitModalOpen] = useState(false)
  const [revalidateModalOpen, setRevalidateModalOpen] = useState(false)
  const [rejectReason, setRejectReason] = useState("")
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false);
  const isPreValidationOrg = useSelector((state) => state?.user?.prevalidationEnabled);
  const loadComponentProps = {
    loader: loading,
    skeletonHeight: '20px',
    skeletonWidth: '100%',
    skeletonVariant: 'reactangle',
    skeletonLines: 1
  };
  const invoiceRuleResults = invoiceDetail?.ruleResult && JSON.parse(invoiceDetail?.ruleResult);
  const sortedPrevalidation = invoiceRuleResults?.preValidationRuleEngineResult && invoiceRuleResults?.preValidationRuleEngineResult?.sort((a, b) => b.validationTs - a.validationTs);
  const [leadAttorney, setLeadAttorney] = useState("");
  const [leadAttorneyLoading, setLeadAttorneyLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const defaultParams = {
    id: invoiceId,
    condition: "AND",
    queryParameters: [
      {
        key: "metaData.invoiceId",
        operation: "match",
        value: invoiceId
      },
      {
        key: "metaData.IL_OBJECT_TYPE",
        operation: "match",
        value: "INVOICE"
      },
      {
        key: "metaData.IL_OBJECT_ID",
        operation: "match",
        value: invoiceId
      }
    ],
    requestedFields: [
      "id",
      "fileName",
      "fileID"
    ]
  }

  /**
     * Fumction to fetch invoice related files
     */
  const getFiles = () => {
    postService(NODE_JS_URL, "/files/search", defaultParams)
      .then((res) => {
        dispatch(setInvoiceFiles(res?.data));
      })
      .catch((error) => {
        dispatch(setInvoiceFiles([]));
        //let it fail silently
      })
  }

  useEffect(() => {
    window.scrollTo({ top: 0, behaviour: 'smooth' })
    fetchInvoiceDetail();
    getCommentsHistory();
    getFiles()
    return () => dispatch(resetInvoiceDetail());
  }, []);

  useEffect(() => {
    setTabIndex(invoiceStatus[invoiceStatusCode]?.progressTrakerIndex)
  }, [invoiceStatusCode])

  const handleInvoiceUpdate = (payload) => {
    dispatch(setInvoiceDetail(payload));
    setInvoiceStatusCode(payload?.status || "Void");
    getLeadAttorneyAndParalegalForInvoice(payload?.matterId);
    setLoading(false);
  };

  /**
   * Function to fetch invoice details of specific invoice id
   */
  const fetchInvoiceDetail = (isPreValidation = false, startTime = Date.now()) => {
    setLoading(true);
    getService(INVOICE_SERVICE, `/invoices/v1/${invoiceId}/summary`)
      .then((res) => {
        const payload = { ...res?.data };

        if (isPreValidation) {
          const elapsedTime = (Date.now() - startTime) / 1000; // Calculate elapsed time in seconds

          if (payload?.status === "Pre-Verification") {
            // Validation is still running server-side - ruleResult on this response (if any)
            // is leftover from a previous run, not this one, so don't inspect it for flags yet.
            if (elapsedTime >= 90) {
              addSnack({
                message: VALIDATION_MSG,
              });
              setRevalidateModalOpen(false);
              handleInvoiceUpdate(payload);
              setResubmitLoading(false);
            } else {
              // Continue polling if status is still "Pre-Verification" and within the 90-second limit
              setTimeout(() => fetchInvoiceDetail(true, startTime), 2000); // Poll every 2 seconds
            }
          } else {
            // Validation has finished - safe to inspect the freshly fetched payload's
            // latest ruleResult entry (by validationTs) for flags.
            const payloadRuleResults = payload?.ruleResult && JSON.parse(payload.ruleResult);
            const payloadPrevalidation = payloadRuleResults?.preValidationRuleEngineResult
              ?.slice()
              ?.sort((a, b) => b.validationTs - a.validationTs);
            const hasFlaggedItems = Boolean(
              Number(payloadPrevalidation?.[0]?.flaggedLineItemCount) > 0 || payloadPrevalidation?.[0]?.Needs_Review
            );

            handleInvoiceUpdate(payload);
            setResubmitLoading(false);
            if (payload?.status !== "Draft" && !hasFlaggedItems) {
              // Clean result - nothing to review, close the gate automatically.
              setRevalidateModalOpen(false);
            }
            // Otherwise (Draft, or flagged items found): leave revalidateModalOpen as-is so the
            // Proceed / Go Back to Review modal stays up and the user explicitly decides.
          }
        }
        else {
          handleInvoiceUpdate(payload);
        }
      })
      .catch((error) => {
        setLoading(false);
        addSnack({
          message: getErrorMessage(error),
        });
      });
  };

  // API to fetch commnets
  const getCommentsHistory = () => {
    getService(INVOICE_SERVICE, `/invoice-comments/v1/invoice/${invoiceId}`)
      .then((res) => {
        const externalComment = res?.data?.comments.filter((row) => row.isExternalComment === true)
        setRejectReason(externalComment?.[0]?.comment ? externalComment?.[0]?.comment : '')
      })
      .catch((error) => {
        setRejectReason('');
      });
  }

  const handleResubmit = (isPreValidation = false) => {
    setResubmitLoading(true)
    setRevalidateModalOpen(isPreValidation)
    patchService(INVOICE_SERVICE, `/invoices/v1/${invoiceId}/resubmit/?isPreValidation=${isPreValidation}`)
      .then(() => {
        if(isPreValidation){
          fetchInvoiceDetail(true)
        }
        else {
          setResubmitModalOpen(false);
          setRevalidateModalOpen(false);
          addSnack({ message: INVOICE_STATUS_CHANGE_SUCCESS });
          fetchInvoiceDetail();
          setResubmitLoading(false)
        }
      })
      .catch((error) => {
        setResubmitModalOpen(false);
        addSnack({
          message: getErrorMessage(error)
        });
        setResubmitLoading(false)
      });
  }
  const loadFieldProps = {
    loader: loading,
    skeletonHeight: '20px',
    skeletonVariant: 'rectangle',
    skeletonLines: 1,
    node: <></>
  };

  /**
   * MakePublicModalActions Actions
   */
  const resubmitModalActions = () => {
    return (
      <Grid>
        <GridColumn sm={5}>
          <ButtonGroup>
            <Button
              data-testid="goback-btn"
              id="goback-btn"
              size="small"
              onClick={() => setResubmitModalOpen(false)}
            >
              {CANCEL}
            </Button>
            <Button
              variant="primary"
              size="small"
              data-testid="continue-btn"
              id="continue-btn"
              onClick={() => handleResubmit(false)}
            >
              {resubmitLoading ? <Spinner size="small" color="white" /> : SUBMIT}
            </Button>
          </ButtonGroup>
        </GridColumn>
      </Grid>
    );
  };

  const revalidateModalActions = () => {
    return (
      <Grid>
        <GridColumn sm={5}>
          <ButtonGroup>
            <Button
              data-testid="goback-btn"
              id="goback-btn"
              size="small"
              onClick={() => setRevalidateModalOpen(false)}
            >
              {GO_BACK_TO_REVIEW}
            </Button>
            <Button
              variant="primary"
              size="small"
              data-testid="continue-btn"
              id="continue-btn"
              onClick={() => { setRevalidateModalOpen(false); handleResubmit(false) }}
            >
              {resubmitLoading ? <Spinner size="small" color="white" /> : PROCEED}
            </Button>
          </ButtonGroup>
        </GridColumn>
      </Grid>
    );
  };

  /**
   * Resubmit confirmation modal.
   */
  const resubmitModal = () => {
    return (
      <Modal
        onClose={() => setResubmitModalOpen(false)}
        isOpen={resubmitModalOpen}
        actions={resubmitModalActions()}
        size="medium"
        title={RESUBMIT_INVOICE}
        data-testid="makePublicModalOpen"
      >
        <Grid>
          <Body as="p" size="large">
            {RESUBMIT_INVOICE_WITHOUT_VALIDATION_MSG}
          </Body>
        </Grid>
      </Modal>
    );
  };

  /**
   * Revalidate confirmation modal.
   */
  const revalidateModal = () => {
    return (
      <Modal
        onClose={() => setRevalidateModalOpen(false)}
        isOpen={revalidateModalOpen}
        actions={resubmitLoading ? <></> : revalidateModalActions()}
        size="medium"
        title={resubmitLoading ? <div className={classes.revalidateSpinner}><Spinner size="small" color="gray" /></div> : <div className={classes.revalidateSpinner}>{REVALIDATION_MODAL_TITLE}</div>}
        data-testid="makePublicModalOpen"
        UNSAFE_className={classes.hideModalTitle}
      >
        <Grid>
          <Body as="p" size="large">
            <div>
              <Divider />
              {resubmitLoading ?
                <>
                  <div className={classes.revalidationTitle}>{REVALIDATION_IN_PROGRESS}</div>
                  <div className={classes.revalidationTxt}>{REVALIDATION_IN_PROGRESS_MSG}</div>
                  <div className={classes.revalidationTxt}> {REVALIDATION_IN_PROGRESS_MSG2} </div>
                  <div className={classes.revalidationTxt}>{REVALIDATION_IN_PROGRESS_MSG3}</div>
                </>
                :
                <>
                  <div className={classes.revalidationModalTitle}>{revalidationLineItemsFlaggedMsg({ count: sortedPrevalidation?.[0]?.flaggedLineItemCount ? sortedPrevalidation?.[0]?.flaggedLineItemCount : 0 })}</div>
                  <div className={classes.revalidationModalTxt}>{REVALIDATION_MODAL_TXT}</div>
                </>
              }
            </div>
          </Body>
        </Grid>
      </Modal>
    );
  };

  // To fetch Lead Attorney Or Lead Paralegal Name from Graph Search
  const getLeadAttorneyAndParalegalForInvoice = (matterId) => {
    setLeadAttorneyLoading(true)
    getLeadAttorneyOrParalegalWithMatterID(matterId, IS_LEAD_ATTORNEY).then((response) => {
      setLeadAttorney((response?.firstName && response?.lastName) ? `${response?.firstName} ${response?.lastName}` : "-")
      setLeadAttorneyLoading(false)
    }).catch((error) => {
      setLeadAttorneyLoading(false)
      addSnack({
        message: getErrorMessage(error)
      });
    });
  }

  /**
    * To export invoice as email
  */
  const exportInvoice = () => {
    setExportLoading(true)
    getService(
      INVOICE_SERVICE,
      `/search/invoices/v1/${invoiceId}/export-email`
    )
      .then(() => {
        addSnack({
          message: INVOICE_EMAIL_MSG
        });
        setExportLoading(false)
      })
      .catch((error) => {
        addSnack({
          message: getErrorMessage(error)
        });
        setExportLoading(false)
      });
  }

  const getCurrentDate = () => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(today.getDate()).padStart(2, '0');
    const year = today.getFullYear();
    return `${month}${day}${year}`;
  };

  const exportLineItemDetails = () => {
    setExportLoading(true);
    getService(INVOICE_SERVICE, `/search/invoices/v1/${invoiceId}/export-invoice`)
      .then((res) => {
        const data = res?.data;
        const contentType = res?.headers["content-type"];
        getExportedData(data, contentType, `${invoiceDetail?.matterNumber}_${invoiceDetail?.organizationInvoiceNumber}_${getCurrentDate()}`);
        setExportLoading(false);
      })
      .catch((error) => {
        setExportLoading(false);
        addSnack({
          message: getErrorMessage(error)
        });
      });
  };

  /**
   * calls this function when we delete the budget.
   **/
  const onDeleteClick = () => {
    setDeleteLoading(true);
    deleteService(INVOICE_SERVICE, `/invoices/v1/${invoiceId}`)
      .then((res) => {
        setTimeout(() => {
          setDeleteLoading(false);
          history.push(`/financial`, { currentFinancialTab: 1 })
        }, 2000);
      })
      .catch((error) => {
        setDeleteLoading(false);
        addSnack({
          message: getErrorMessage(error)
        });
      });
  }

  const defaultFilterCondition = `${formSearchQuery(
    "isActive",
    Operations.EQ,
    true,
    'boolean'
  )}+${formSearchQuery(
    "invoice.id",
    Operations.EQ,
    invoiceId,
    'id'
  )}`;

  const exportLineItemsOnly = () => {
    setLoading(true);
    const sortQuery = "&order=lineItemDate DESC"
    getService(INVOICE_SERVICE, `/search/line-items/v1/?csv=true&filter=${defaultFilterCondition}&${sortQuery}`)
      .then((res) => {
        const data = res?.data;
        const contentType = res?.headers?.["content-type"];
        getExportedData(data, contentType, 'line-items');
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        addSnack({
          message: getErrorMessage(error)
        });
      });
  };

  const exportPDF = () => {
    const date = moment(new Date())?.format(DATE_MMM_DD_YYYY)
    setLoading(true)
    getServiceWithResponseType(
      INVOICE_SERVICE,
      `/search/invoices/v1/${invoiceId}/export-invoice?pdf=true`, 'arraybuffer'
    )
      .then((res) => {
        const data = res?.data;
        const contentType = res?.headers?.["content-type"];
        getExportedData(data, contentType, `${invoiceDetail?.matterNumber}_${invoiceDetail?.organizationInvoiceNumber}_${date}`);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        addSnack({
          message: getErrorMessage(error)
        });
      });
  }

  const handleExportClick = (selectedId) => {
    switch (selectedId) {
      case 0:
        exportLineItemDetails()
        break;
      case 1:
        exportLineItemsOnly()
        break;
      case 2:
        exportInvoice()
        break;
      case 3:
        exportPDF()
        break;
      default:
        break;
    }
  }
  return (
    <div className={classes.listing}>
      <Grid>
        <GridColumn sm={7}>
          {fromMatter ?
            <Breadcrumb>
              <BreadcrumbItem
                data-testid="invoice-nav-matter"
                onClick={() => history.push(`/`)}
              >
                Matters</BreadcrumbItem>
              <BreadcrumbItem
                data-testid="invoice-nav-matter-detail"
                onClick={() => history.push(`/matter/${matterDetail?.matter?.identifier}`)}
              >
                #{matterNumber}</BreadcrumbItem>
              <BreadcrumbItem
                data-testid="invoice-nav-matter-invoice-list"
                onClick={() => history.push(`/matter/${matterDetail?.matter?.identifier}`,
                  { currentMatterTab: currentMatterTab, currentFinancialTab: 1 })}>Financials</BreadcrumbItem>
              <BreadcrumbItem isCurrent>#{invoiceDetail?.organizationInvoiceNumber}</BreadcrumbItem>
            </Breadcrumb>
            :
            <Breadcrumb>
              <BreadcrumbItem data-testid="invoice-nav-matter-financial" onClick={() => history.push(`/financial`, { currentFinancialTab: 1 })}>Financials</BreadcrumbItem>
              <BreadcrumbItem isCurrent>#{invoiceDetail?.organizationInvoiceNumber}</BreadcrumbItem>
            </Breadcrumb>
          }
        </GridColumn>
        {accessibility?.edit && !loading && invoiceStatus[invoiceStatusCode]?.showHeaderActionPanel ?
          <GridColumn sm={5}>
            <div className={classes.icons}>
              {accessibility?.edit && !loading && invoiceStatus[invoiceStatusCode]?.deleteInvoice && isPreValidationOrg &&
                <Tooltip title={DELETE}>
                  <IconButton
                    a11yLabel={"delete-icon"}
                    size="medium"
                    onClick={() => setDeleteOpen(true)}
                    disabled={loading}
                  >
                    <Trash a11yLabel={"delete-icon"} size="medium" data-testid="delete-icon" />
                  </IconButton>
                </Tooltip>
              }
              {
                accessibility?.edit && (invoiceStatusCode?.toLowerCase() === LABEL_FAILED?.toLowerCase() || invoiceStatusCode?.toLowerCase() === LABEL_APPEALED) &&
                <Tooltip title={RESUBMIT}>
                  <IconButton
                    size="medium"
                    onClick={() => setResubmitModalOpen(true)}
                    a11yLabel="resubmit-invoice-btn"
                    data-testid="resubmit-invoice-btn"
                    id="resubmit-invoice-btn"
                    disabled={resubmitLoading}
                  >
                    <Refresh size="medium" />
                  </IconButton>
                </Tooltip>
              }
              {(invoiceStatusCode?.toLowerCase() === LABEL_DRAFT) &&
                <Tooltip title={REVALIDATE_AND_SUBMIT}>
                  <IconButton
                    size="medium"
                    onClick={() => { handleResubmit(true) }}
                    a11yLabel="resubmit-invoice-btn"
                    data-testid="resubmit-invoice-btn"
                    id="resubmit-invoice-btn"
                    disabled={resubmitLoading}
                  >
                    <CheckCircleFill size="medium" />
                  </IconButton>
                </Tooltip>
              }
              <ActionPopover
                actionItems={INVOICE_EXPORT_ACTIONS}
                onClickOption={handleExportClick}
                data-testid="export-invoice"
                buttonText={EXPORT}
                disableStatus={exportLoading}
                renderIcon={EXPORT}
              />
            </div>
          </GridColumn>
          : <></>
        }
      </Grid>
      {
        (!TERMINAL_STATUSES?.includes(invoiceStatusCode)) && isPreValidationOrg &&
        LoadField({
          ...loadFieldProps, node:
            <div>
              <ProgressTracker activeIndex={tabIndex} variant="info" >
                <ProgressTrackerItem>{NOT_SUBMITTED}</ProgressTrackerItem>
                <ProgressTrackerItem>{SUBMITTED}</ProgressTrackerItem>
                <ProgressTrackerItem>{PROCESSING_PAYMENT}</ProgressTrackerItem>
                <ProgressTrackerItem>{PAID}</ProgressTrackerItem>
              </ProgressTracker>
            </div>
        })
      }

      {(invoiceStatusCode === LABEL_FAILED || invoiceRuleResults?.ruleEngineResult?.Rejected || invoiceRuleResults?.preValidationRuleEngineResult?.Rejected|| invoiceStatusCode === LABEL_WORKFLOW
        || invoiceStatusCode?.toLowerCase() === LABEL_APPEALED || invoiceStatusCode === LABEL_REJECTED) &&
        LoadField({
          ...loadFieldProps, node: <div className={classes.alertStyle} >
            <Alert
              variant="warning"
              data-testid="alert-bar"
            >
              {INVOICE_WARNING_TITLE_MESSAGE}
            </Alert>
          </div>
        })
      }

      {(invoiceStatusCode?.toLowerCase() === LABEL_DRAFT && sortedPrevalidation?.[0]) &&
        LoadField({
          ...loadFieldProps, node: <div className={classes.alertStyle} >
            <Alert
              variant="warning"
              data-testid="alert-bar"
            >
              {INVOICE_WARNING_TITLE_MESSAGE}
            </Alert>
          </div>
        })
      }

      {invoiceDetail?.rejectReason && invoiceStatusCode?.toLowerCase() === LABEL_REJECTED.toLowerCase() &&
        LoadField({
          ...loadFieldProps, node: <div className={classes.alertStyle}>
            <Alert
              variant="error"
              data-testid="rejected-alert-bar"
            >
              Reject Reason: {invoiceDetail?.rejectReason}<br />
              {rejectReason && `Comment: ${rejectReason}`}
            </Alert>
          </div>
        })
      }
      <div className={classes.gridLayout}>
        <div>
          <LoadComponent {...loadComponentProps}>
            {invoiceDetail?.organizationInvoiceNumber ?
              <Heading as="h1" size="small" UNSAFE_className={classes.pageTitle}>
                <span id="inv-det-invoiceNumber">#{invoiceDetail?.organizationInvoiceNumber}</span>
                <span className={classes.pageTitleBadge}>
                  <Tag
                    color={invoiceStatus[invoiceStatusCode]?.color}
                    variant="tertiary"
                    data-testid={`invoice-status-tag-${invoiceStatusCode}`}
                    id={`invoice-status-tag-${invoiceStatusCode}`}
                  >
                    {invoiceStatus[invoiceStatusCode]?.displayLabel}
                  </Tag>
                </span>
                {invoiceStatusCode === "Pre-Verification" &&
                  <span className={classes.infoButton}>
                    <Tooltip title={CREATED_INFO_MSG}>
                      <IconButton
                        a11yLabel={"info-icon"}
                        size="small"
                        disabled={loading}
                      >
                        <QuestionCircle a11yLabel={"info-icon"} size="small" data-testid="info-icon" />
                      </IconButton>
                    </Tooltip>
                  </span>}
              </Heading> : '-'
            }
          </LoadComponent>
        </div>
      </div>
      <div className={classes.pageTitleGroup}>
        <Caption as="small" UNSAFE_className={classes.invoiceDateSubtitle}>
          <LoadComponent {...{ ...loadComponentProps, skeletonHeight: '21px', width: '180px' }}>
            {invoiceDetail?.startDate ?
              `${displayLocalDate(invoiceDetail?.startDate)} - ${displayLocalDate(invoiceDetail?.endDate)}`
              : '-'
            }
          </LoadComponent>
        </Caption>
      </div>
      <div className={classes.gridLayout}>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="small">
              Matter Number
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            <LoadComponent {...loadComponentProps}>
              <Heading as="h4" size="small" id={`matter-number-${invoiceDetail?.matterNumber}`}>
                {invoiceDetail?.matterNumber || '-'}
              </Heading>
            </LoadComponent>
          </div>
        </div>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="small">
              {MATTER_NAME}
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            <LoadComponent {...loadComponentProps}>
              <Heading as="h4" size="small" id={`matter-name-${invoiceDetail?.matterName}`}>
                {invoiceDetail?.matterName || '-'}
              </Heading>
            </LoadComponent>
          </div>
        </div>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="large">
              Organization
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            <LoadComponent {...{ ...loadComponentProps }}>
              <Heading as="h4" size="small">
                {invoiceDetail?.organizationName || '-'}
              </Heading>
            </LoadComponent>
          </div>
        </div>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="large">
              Created Date
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            <LoadComponent {...{ ...loadComponentProps }}>
              <Heading as="h4" size="small">
                {invoiceDetail?.createdTs ? displayLocalDate(invoiceDetail?.createdTs) : '-'}
              </Heading>
            </LoadComponent>
          </div>
        </div>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="large">
              Invoice Date
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            <LoadComponent {...{ ...loadComponentProps }}>
              <Heading as="h4" size="small">
                {invoiceDetail?.invoiceDate ? displayLocalDate(invoiceDetail?.invoiceDate) : '-'}
              </Heading>
            </LoadComponent>
          </div>
        </div>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="large">
              Received Date
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            <LoadComponent {...{ ...loadComponentProps }}>
              <Heading as="h4" size="small">
                {invoiceDetail?.receivedDate ? displayLocalDate(invoiceDetail?.receivedDate) : '-'}
              </Heading>
            </LoadComponent>
          </div>
        </div>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="large">
              Type
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            <LoadComponent {...{ ...loadComponentProps }}>
              <Heading as="h4" size="small">
                {invoiceDetail?.invoiceType || '-'}
              </Heading>
            </LoadComponent>
          </div>
        </div>
        <div>
          <div className={classes.label}>
            <Caption as="span" size="large">
              {LEAD_ATTORNEY}
            </Caption>
          </div>
          <div className={classes.pageInfoBold}>
            {LoadField({
              ...loadFieldProps, loader: leadAttorneyLoading, node:
                <Heading as="h4" size="small">
                  {isValueEmptyCheck(leadAttorney)}
                </Heading>
            })}
          </div>
        </div>
      </div>
      <InvoiceDetailsTiles invoiceDetail={invoiceDetail} loading={loading} />
      <TabsLayout loading={loading || statusModalOpen} listOfTab={listOfTabs} tabIndexMap={tabIndexMap} listOfTabs={listOfTabs} invoiceDetail={invoiceDetail} fetchInvoiceDetail={fetchInvoiceDetail} invoiceStatusCode={invoiceStatusCode} fromMatter={fromMatter} currentMatterTab={currentMatterTab} />
      <InvoiceChangeStatusModal
        open={statusModalOpen}
        actionId={''}
        handleStatusModalState={setStatusModalOpen}
        invoiceId={invoiceId}
        handleStatusCodeChange={setInvoiceStatusCode}
      />
      {resubmitModal()}
      {revalidateModal()}
      <DeleteModal
        open={deleteOpen}
        setOpen={setDeleteOpen}
        title={CONFIRM_INVOICE_DELETION}
        message={INVOICE_DELETE_MSG}
        deleteButtonText={DELETE}
        onDelete={() => onDeleteClick()}
        deleteLoading={deleteLoading}
      />
    </div>
  );
};

export default InvoiceDetails;
